// Settings — Appearance (theme, mirroring the patient portal's Settings → Appearance) + operational
// config surfaced from the API (scheduling lead-time / fair-use knobs, reminder offsets, EMR adapter).
// Read-only for the operational knobs; no secrets in the UI.
import { Surface, useTheme } from "@championcare/ui";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";
import { Loading, ErrorState, PageHeader } from "../components/ui";

export function Settings() {
  const api = useApi();
  const { theme, setTheme } = useTheme();
  const { data, loading, error } = useAsync(() => api.settings(), []);
  if (loading) return <Loading />;
  if (error) return <ErrorState message={error} />;
  if (!data) return <ErrorState message="Unavailable." />;

  return (
    <div className="page">
      <PageHeader title="Settings" sub="Appearance and operational configuration." />

      {/* Appearance — theme picker, mirroring the patient portal's Settings → Appearance. */}
      <Surface className="card">
        <h2 className="card__title">Appearance</h2>
        <p className="muted" style={{ marginBottom: 16 }}>Choose how the command console looks. Saved on this device.</p>
        <div className="theme-tiles">
          <button className={`theme-tile light ${theme === "light" ? "selected" : ""}`} onClick={() => setTheme("light")}>
            <div className="theme-tile-preview" />
            <div className="theme-tile-label">Light</div>
          </button>
          <button className={`theme-tile dark ${theme === "dark" ? "selected" : ""}`} onClick={() => setTheme("dark")}>
            <div className="theme-tile-preview" />
            <div className="theme-tile-label">Dark</div>
          </button>
        </div>
      </Surface>

      <h2 className="section-title">Operational configuration</h2>
      <Surface className="card">
        <dl className="kv">
          <div>
            <dt>Reschedule lead (min)</dt>
            <dd className="mono">{data.reschedule_min_lead_minutes}</dd>
          </div>
          <div>
            <dt>Cancel lead (min)</dt>
            <dd className="mono">{data.cancel_min_lead_minutes}</dd>
          </div>
          <div>
            <dt>Late-cancel policy</dt>
            <dd>{data.late_cancel_policy.replace(/_/g, " ")}</dd>
          </div>
          <div>
            <dt>Visit reminders</dt>
            <dd className="mono">{data.visit_reminder_offsets.join(", ")}</dd>
          </div>
          <div>
            <dt>EMR adapter</dt>
            <dd className="mono">{data.emr_adapter}</dd>
          </div>
        </dl>
        <p className="muted">
          These values are configured via environment (Doppler) and applied across the platform.
        </p>
      </Surface>
    </div>
  );
}
